import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/components/Login/Login';
import OfficerDetails from '@/components/Officer/OfficerDetails';
import MemberDetails from '@/components/Member/MemberDetails';
import ClubCount from '@/components/ClubCount/ClubCount.vue';
import KnowledgeBase from '@/components/KnowledgeBase/KnowledgeBase.vue';
import Settings from '@/components/Settings/Settings.vue';
import KnowledgeBaseFolder from '@/components/Settings/KnowledgeBaseFolder.vue';


Vue.use(Router);
const router = new Router(
    {
        mode: 'history',
        routes: [
            {
                path: '/',
                name: 'Login',
                component: Login
            },
            {
                path: '/clubs/:district/:taluka/:club',
                name: 'Clubs',
                component: require('../components/Club/Clubs.vue').default,
                meta: {requireAuth: true}
            },
            {
                path: '/myclubs/:district/:taluka/:club',
                name: 'MyClubs',
                component: require('../components/Club/MyClubs.vue').default,
                meta: {requireAuth: true}
            },

            {
                path: '/members/:id',
                name: 'MemberDetails',
                component: require('../components/Member/MemberDetails.vue').default,
                meta: {requireAuth: true}
            },

            {
                path: '/officers',
                name: 'OfficerDetails',
                component: OfficerDetails,
                meta: {requireAuth: true}
            },
            {
                path: '/clubcount',
                name: 'ClubCount',
                component: ClubCount,
                meta: {requireAuth: true}
            },
            {
                path: '/knowledgebase',
                name: 'KnowledgeBase',
                component: KnowledgeBase,
                meta: {requireAuth: true}
            },
            {
                path: '/settings',
                name: 'Settings',
                component: Settings,
                meta: {requireAuth: true}
            },
            {
                path: '/settings/knowledgebase-folder',
                name: 'KnowledgeBaseFolder',
                component: KnowledgeBaseFolder,
                meta: {requireAuth: true}
            },
        ]
    }
    )
;
export default router
router.beforeEach((to, from, next) => {
    if (to.meta.requireAuth) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!loggedIn()) {
            next({
                path: '/'
            })
        } else {
            next()
        }
    } else {
        next() // make sure to always call next()!
    }
})

export function loggedIn() {
    // if (localStorage.getItem('token')) return true
    if (localStorage.getItem('token')) {
        axios.defaults.headers.common['token'] = localStorage.getItem('token');
        return true
    }
}



// WEBPACK FOOTER //
// ./src/router/index.js